export const PlayerFlag = {
  Reloading: 1,
  Paused: 2,
  Firing: 4,
  Disconnected: 8,
} as const;
